/*
 * @Author: Duanjiaojiao
 * @Date: 2022-05-12 11:13:51
 * @LastEditors: Duanjiaojiao
 * @LastEditTime: 2022-08-30 09:58:04
 * @Description: 定位t值为null的原因，上报埋点
 * @FilePath: /BM-Main/src/utils/judgeT.js
 * @props:
 */
import { cookie, url as $URL } from '@zz-common/zz-utils'
import { catchErrSendLego } from '@/utils/helper'
/**
 * 匹配t或这zz_t
 */
const matchT = () => {
  return /;\s*(t|zz_t)=\d+\s*;?/g.test(document.cookie)
}
/**
 * 获取到t或zz_t
 */
export const getT = () => {
  return cookie.get('t') || cookie.get('zz_t')
}

// 判断否是微信小程序环境
export const isMiniprogram = () => {
  return (
    navigator.userAgent.match(/micromessenger/i) &&
      navigator.userAgent.match(/miniprogram/i)
  ) ||
    window.__wxjs_environment === 'miniprogram'
}

const getTFromUA = () => {
  const UA = navigator.userAgent
  // 转转端内
  if (/58ZhuanZhuan$/g.test(UA)) {
    if (/\(i[^;]+;( U;)? CPU.+Mac OS X/gi.test(UA)) {
      return (matchT() && +getT() !== 16 && 16) || 16
    } else { // android
      return (matchT() && +getT() !== 15 && 15) || 15
    }
  } else if (/aweme/gi.test(UA)) { // 抖音
    return 76
  } else if (/kwai/gi.test(UA)) { // 快手
    return 77
  }
}

export const judgeT = (url) => {
  try {
    const urlparams = $URL.getParams()
    const ua = navigator.userAgent
    const t = cookie.get('t')
    const feUrl = location.href
    if (+t) return

    // 上报埋点
    catchErrSendLego('t_error', {
      t,
      urlparams,
      ua,
      api: url, // 后端接口
      feUrl // 前端链接
    })
    // 先取参数的值
    // 再从url参数中取
    // 最后从ua中取
    const tvalue = urlparams?.__t || getTFromUA()
    // 主动存一下
    cookie.set('t', tvalue, {
      domain: 'zhuanzhuan.com',
      path: '/',
      expires: 90
    })
  } catch (e) {

  }
}
